import classNames from "classnames";
import React, { FC } from "react";

import Logo from "../../assets/images/KokoroLogoHeader.png";
import { Image } from "../elements";
import "./Logo_kokoro.scss";

interface ILogoProps {
	"data-testid"?: string;
	className?: string;
}

const kokoroLogo: FC<ILogoProps> = (props) => {
	return (
		<div
			data-testid={props["data-testid"] ?? "LogoCntr"}
			className={classNames("LogoCntr", props.className)}
		>
			<Image src={Logo} alt="Kokoro" className="Logo" />
		</div>
	);
};

export default React.memo(kokoroLogo);
